import { render, staticRenderFns } from "./AccrualsConfiguration.vue?vue&type=template&id=710c7d30&scoped=true"
import script from "./AccrualsConfiguration.vue?vue&type=script&lang=js"
export * from "./AccrualsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AccrualsConfiguration.vue?vue&type=style&index=0&id=710c7d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c7d30",
  null
  
)

export default component.exports